import {
  createConsiliApi,
  injectLogoutEndpoint,
  addConsiliApi,
} from './createApi';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getRequestHeaders } from '../utils/getHeaderData';
import { API_URL, endpointTags } from '../constants';
// Login API
export const loginApi = createConsiliApi('login', '/login/', 'POST', [
  'Interest',
  'User',
  'Category',
  'Insight',
]);
export const { useLazyLoginQuery } = loginApi;

// Logout API
export const logoutApi = injectLogoutEndpoint('logout', '/logout/', 'POST', [
  'Interest',
  'User',
  'Category',
  'Insight',
  'Source',
]);
export const { useLazyLogoutQuery } = logoutApi;

// User API
export const userApi = createConsiliApi('user', '/me/', 'GET');
export const { useUserQuery } = userApi;

// All Users API
export const allUsersApi = createConsiliApi('allUsers', '/user/', 'GET');
export const { useAllUsersQuery } = allUsersApi;

export const userIdApi = createApi({
  reducerPath: 'UserIdAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    userId: builder.query({
      query: (userId) => ({
        url: `/user/${userId}/`,
        headers: getRequestHeaders(),
        method: 'GET',
      }),
    }),
  }),
});

export const { useUserIdQuery } = userIdApi;

export const userSettingsApi = injectLogoutEndpoint(
  'userSettings',
  '/user/settings/',
  'GET',
  []
);
export const { useUserSettingsQuery } = logoutApi;

export const updateUserSettingsApi = addConsiliApi(
  'updateUserSettings',
  () => `/user/settings/`,
  'PATCH',
  ['User', 'UserSettings']
);
export const { useUpdateUserSettingsMutation } = updateUserSettingsApi;

export const constantsApi = injectLogoutEndpoint(
  'constants',
  '/constants/',
  'GET',
  []
);
export const { useConstantsQuery } = constantsApi;

export const registerApi = createConsiliApi(
  'register',
  '/register/',
  'POST',
  endpointTags
);
export const { useLazyRegisterQuery } = registerApi;
